<ng-container *ngIf="this.uploaded == 0">
   <div class="upload">
      <main>
         <div (click)="upload()" style="cursor: pointer">
            <img src="../../assets/images/upload.png" alt="" />
            <h6>{{ 'individual.upload.dropzone_text' | translate }}</h6>
         </div>
         <a (click)="upload()" class="submit">{{
            'general.upload' | translate
         }}</a>
      </main>
   </div>
   <input
      class="dropzone"
      type="file"
      name=""
      id=""
      (change)="onFileSelected($event)"
      accept="application/pdf, .docx"
      style="display: none"
   />
</ng-container>

<ng-container *ngIf="this.uploaded == 1">
   <div class="file-uploads">
      <main>
         <div>
            <form [formGroup]="uploadForm">
               <h5 class="bold">
                  {{ 'individual.upload.upload_form' | translate }}
               </h5>
               <h5>{{ 'individual.upload.document_title' | translate }}</h5>
               <input type="text" formControlName="documentTitle" disabled />
               <div
                  *ngIf="
                     form.documentTitle.invalid && form.documentTitle.touched
                  "
                  class="invalid"
               >
                  <div *ngIf="form.documentTitle.errors.required">
                     {{ 'app.upload.document_title' | translate }} {{ 'general.end_date' | translate }}*
                  </div>
               </div>
               <h5>{{ 'general.name_and_surname' | translate }}</h5>
               <input type="text" formControlName="fullName" disabled />
               <div
                  *ngIf="form.fullName.invalid && form.fullName.touched"
                  class="invalid"
               >
                  <div *ngIf="form.fullName.errors.required">
                     {{ 'general.full_name' | translate }} {{ 'aria-labels.is_required' | translate }}*
                  </div>
               </div>
               <h5>{{ 'individual.upload.date_of_upload' | translate }}</h5>
               <input formControlName="dateOfUpload" disabled type="text" />
               <h5>{{ 'individual.upload.document_size' | translate }}</h5>
               <input formControlName="documentSize" disabled type="text" />
               <h5>{{ 'general.credits_to_be_charged' | translate }}:</h5>
               <input formControlName="documentCredits" disabled type="text" />
               <h5 *ngIf="this.user?.institutionId !== null">{{ 'app.thesis_language' | translate }}</h5>
               <h5 *ngIf="this.user?.institutionId === null">
                  {{ 'individual.upload.document_language' | translate }}
               </h5>
               <div style="position: relative">
                  <ng-container *ngIf="this.disableField === true">
                     <select
                        (change)="selectLanguage($event.target.value)"
                        formControlName="documentLanguage"
                        disabled
                        class="border"
                        name=""
                        id=""
                     >
                        <option value="-1" selected>{{ 'general.select_language' | translate }}</option>
                        <option
                           *ngFor="let language of languages"
                           value="{{ language.value }}"
                        >
                           {{ language.text }}
                        </option>
                        <span
                           ><img src="../../assets/images/Path 26.png" alt=""
                        /></span>
                     </select>
                  </ng-container>
                  <ng-container *ngIf="this.disableField === false">
                     <select
                        (change)="selectLanguage($event.target.value)"
                        formControlName="documentLanguage"
                        class="border"
                        name=""
                        id=""
                     >
                        <option value="-1" selected>{{ 'general.select_language' | translate }}</option>
                        <option
                           *ngFor="let language of languages"
                           value="{{ language.value }}"
                        >
                           {{ language.text }}
                        </option>
                        <span
                           ><img src="../../assets/images/Path 26.png" alt=""
                        /></span>
                     </select>
                  </ng-container>
                  <span
                     ><img src="../../assets/images/Path 26.png" alt=""
                  /></span>
               </div>
               <div
                  *ngIf="form.documentLanguage.invalid && languageSelected"
                  class="invalid"
                  for
               >
                  <div
                     *ngIf="
                        form.documentLanguage.errors.required ||
                        form.documentLanguage.value == 'undefined'
                     "
                  >
                     {{ 'report.document_language' | translate }} {{ 'aria-labels.is_required' | translate }}*
                  </div>
               </div>
               <h5 *ngIf="this.user?.institutionId !== null">
                  Thesis Translation Language
               </h5>
               <h5 *ngIf="this.user?.institutionId === null">
                  {{ 'individual.upload.translate_document' | translate }}
               </h5>
               <div style="position: relative">
                  <ng-container *ngIf="this.disableField === true">
                     <select
                        (change)="selectTranslatedLanguage($event.target.value)"
                        formControlName="documentTranslatedLanguage"
                        class="border"
                        disabled
                        name=""
                        id=""
                     >
                        <option value="-1" selected>{{ 'general.none' | translate }}</option>
                        <option
                           *ngFor="let language of languages"
                           value="{{ language.value }}"
                        >
                           {{ language.text }}
                        </option>
                        <span
                           ><img src="../../assets/images/Path 26.png" alt=""
                        /></span>
                     </select>
                  </ng-container>
                  <ng-container *ngIf="this.disableField === false">
                     <select
                        (change)="selectTranslatedLanguage($event.target.value)"
                        formControlName="documentTranslatedLanguage"
                        class="border"
                        name=""
                        id=""
                     >
                        <option value="-1" selected>{{ 'general.none' | translate }}</option>
                        <option
                           *ngFor="let language of languages"
                           value="{{ language.value }}"
                        >
                           {{ language.text }}
                        </option>
                        <span
                           ><img src="../../assets/images/Path 26.png" alt=""
                        /></span>
                     </select>
                  </ng-container>
                  <span
                     ><img src="../../assets/images/Path 26.png" alt=""
                  /></span>
               </div>
               <div
                  class="advanced_options"
                  *ngIf="this.user?.institutionId === null"
               >
                  <h4 (click)="advancedOptions()">
                     Advanced options<img
                        [ngClass]="{ expand: advancedOptionsIndex == true }"
                        src="../../assets/images/Path 26.png"
                        alt=""
                     />
                  </h4>
                  <div *ngIf="advancedOptionsIndex == true">
                     <div class="flex add_to_archive">
                        <input
                           type="checkbox"
                           id="add_to_archive"
                           value="{{ archive }}"
                           name="add_to_archive"
                           [(ngModel)]="archive"
                           (click)="archiveDocument()"
                           [ngModelOptions]="{ standalone: true }"
                        />
                        <label for="add_to_archive"></label>
                        <label for="">
                           {{ 'new_entries.add_document_to_archive' | translate }}<i
                              class="fas fa-info-circle"
                              matTooltipPosition="after"
                              matTooltipClass="tooltipCustomCss"
                              matTooltip="If you {{ 'new_entries.add_document_to_archive' | translate }},all uploaded
                                documents will search for plagiarism from this
                                document"
                           ></i>
                        </label>
                     </div>
                     <div>
                        <label for="">
                           <h4>{{ 'general.choose_third_party_libraries' | translate }}</h4>
                           <i
                              style="margin-left: 1%"
                              matTooltipPosition="after"
                              class="fas fa-info-circle"
                              matTooltipClass="tooltipCustomCss"
                              matTooltip="Cross-checking your document with third-party libraries and archives may delay checking your document for up to several hours. Please be aware!"
                           ></i>
                        </label>
                        <div class="">
                           <div
                              *ngFor="
                                 let library of thirdPartyLib;
                                 let i = index
                              "
                           >
                              <input
                                 type="checkbox"
                                 id="library{{ i }}"
                                 [value]="library.description"
                                 [checked]="library.isChecked"
                                 name="library{{ i }}"
                                 (change)="onCheckboxChange($event)"
                              />
                              <label for="library{{ i }}"
                                 >{{ library.description }}
                                 <i
                                    style="margin-left: 1%"
                                    class="fas fa-info-circle"
                                    matTooltip="{{ library.information }}"
                                    matTooltipPosition="after"
                                    matTooltipClass="tooltipCustomCss"
                                 ></i
                              ></label>
                           </div>
                        </div>
                     </div>
                     <div>
                        <h4>{{ 'general.choose_citation' | translate }}</h4>
                        <div style="position: relative">
                           <select
                              (change)="selectCitationStyle($event)"
                              [(ngModel)]="citationStyle"
                              class="border"
                              name=""
                              id=""
                              [ngModelOptions]="{ standalone: true }"
                           >
                              <option value="" selected>
                                 {{ 'new_entries.select_citation_style' | translate }}
                              </option>
                              <optgroup [label]="'new_entries.popular_formats' | translate">
                                 <option value="AMA">{{ 'general.ama' | translate }}</option>
                                 <option value="APA(6th edition)">
                                    {{ 'other.apa_6th_edition' | translate }}
                                 </option>
                                 <option value="APA(7th edition)">
                                    {{ 'other.apa_7th_edition' | translate }}
                                 </option>
                                 <option value="Harvard">{{ 'general.harvard' | translate }}</option>
                                 <option value="IEEE">{{ 'general.ieee' | translate }}</option>
                              </optgroup>
                              <optgroup [label]="'new_entries.others' | translate">
                                 <option value="OSCOLA">{{ 'general.oscola' | translate }}</option>
                                 <option value="MHRA(3rd edition)">
                                    {{ 'other.mhra_third_edition' | translate }}
                                 </option>
                                 <option value="Vancouver">{{ 'general.vancouver' | translate }}</option>
                              </optgroup>
                           </select>
                           <span class="chevron-icon"
                              ><img
                                 src="../../assets/images/Path 26.png"
                                 alt=""
                           /></span>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="center">
                  <button
                     *ngIf="!uploadForm.invalid"
                     [ngClass]="{ disable: uploadForm.invalid }"
                     class="submit"
                     (click)="createSubmission()"
                  >
                     {{ 'general.submit' | translate }}
                  </button>

                  <button
                     *ngIf="uploadForm.invalid"
                     [ngClass]="{ disable: uploadForm.invalid }"
                     (click)="showFormMessages()"
                     class="submit"
                  >
                     {{ 'general.submit' | translate }}
                  </button>
               </div>
            </form>
         </div>
         <div class="file">
            <pdf-viewer
               id="viewer"
               [src]="this.previewSrc"
               [fit-to-page]="true"
               style="
                  display: block;
                  overflow: auto;
                  height: 650px;
                  scroll-behavior: smooth;
                  border-radius: 10px;
               "
            ></pdf-viewer>

            <div
               style="
                  background: #eee;
                  padding-bottom: 1%;
                  border-radius: 10px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-direction: column;
               "
            >
               <h6>{{ 'individual.upload.document_preview' | translate }}</h6>
               <p>{{ 'individual.upload.check_your_document' | translate }}</p>
            </div>
         </div>
      </main>
   </div>
</ng-container>
